const LeasingHeader = () => {
  return (
    <div className="individual-leasings__header">
      <div className="individual-leasings__header-title">
        <h2>Заявления</h2>
        <p>Созданные заявки на лизинг</p>
      </div>
    </div>
  );
};

export default LeasingHeader;
